export default __webpack_public_path__ + "static/media/fcv-charging-cost.99ecedfe.svg";